import { hasFirebaseUserId } from "../token-utils";

export type SessionUpdateResult =
  | {
      databaseApiAccessToken?: string;
      user?: { providerUserId?: string };
    }
  | null
  | undefined;

export function didAcceptLegacySessionUpgrade({
  firebaseIdToken,
  firebaseUserId,
  updatedSession,
}: {
  firebaseIdToken: string;
  firebaseUserId: string;
  updatedSession: SessionUpdateResult;
}): boolean {
  const updatedAccessToken = updatedSession?.databaseApiAccessToken;
  if (!updatedAccessToken) return false;
  if (updatedAccessToken !== firebaseIdToken) return false;
  if (updatedSession?.user?.providerUserId !== firebaseUserId) return false;
  return !hasFirebaseUserId(updatedAccessToken);
}
